// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { noteSchema } from '@/note/api/types';

const addProjectNoteResponseSchema = z.object({
  data: noteSchema,
  metadata: responseMetadataSchema,
});

type AddProjectNoteResponse = z.infer<typeof addProjectNoteResponseSchema>;

/**
 * Add a note to a project
 * @param projectKey The key of the project
 * @param content The content of the note
 * @returns A promise that resolves to the add note response
 */
export async function addProjectNote(
  projectKey: string,
  content: string
): Promise<AddProjectNoteResponse> {
  const url = `/v1/project/${projectKey}/note`;
  const response = await api.post(url, { content });

  return parseResponse(addProjectNoteResponseSchema, response.data, {
    schemaName: 'AddProjectNote',
    endpoint: url,
  });
}
